"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));
var _every = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/every"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _input = _interopRequireDefault(require("react-phone-number-input/input"));
var _reactPhoneNumberInput = require("react-phone-number-input");
var _styles = require("./styles");
/**
 * Input that handles formatting and validation of phone numbers.
 *
 * Uses React Phone Number Input
 * http://catamphetamine.github.io/react-phone-number-input/docs/styleguide/index.html#phoneinput
 */
class PhoneInput extends _react.default.PureComponent {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      value: this.props.initialValue,
      errors: new _set.default(),
      isDirty: false
    });
    (0, _defineProperty2.default)(this, "handleChange", value => {
      this.setState({
        value: value || '',
        errors: new _set.default(),
        isDirty: true
      }, () => this.props.onChange({
        value: value || '',
        errors: []
      }));
    });
    (0, _defineProperty2.default)(this, "handleBlur", () => {
      const validationError = this.props.validate && this.getPhoneValidationError(this.state.value || '');
      const errors = new _set.default(this.state.errors);
      validationError && errors.add(validationError);
      const onChangePayload = {
        value: this.state.value,
        errors: (0, _from.default)(errors)
      };
      this.setState({
        ...onChangePayload,
        isDirty: true
      }, () => this.props.onChange(onChangePayload));
    });
    (0, _defineProperty2.default)(this, "getPhoneValidationError", phoneNumber => {
      const isInvalid = !(0, _reactPhoneNumberInput.isPossiblePhoneNumber)(phoneNumber);
      if (isInvalid && this.state.value) {
        return this.props.invalidMsg;
      }
      return '';
    });
  }
  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (props.initialValue && !state.isDirty) {
      newState = {
        ...newState,
        value: props.initialValue
      };
    }
    if (props.errors) {
      var _context;
      const newErrors = new _set.default(props.errors);
      const currentErrors = state.errors;

      // Check if errors have actually changed
      const errorsChanged = newErrors.size !== currentErrors.size || !(0, _every.default)(_context = [...newErrors]).call(_context, error => currentErrors.has(error));
      if (errorsChanged) {
        newState = {
          ...newState,
          errors: newErrors
        };
      }
    } else if (state.errors.size > 0 && props.errors !== undefined) {
      // Clear errors if props.errors is explicitly set to empty array or null
      newState = {
        ...newState,
        errors: new _set.default()
      };
    }
    return newState;
  }
  render() {
    const {
      placeholder,
      countryFormat
    } = this.props;
    const errorList = (0, _from.default)(this.state.errors);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.StyledPhoneInput, null, /*#__PURE__*/_react.default.createElement(_styles.FieldErrorWrapper, {
      errors: errorList,
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      id: this.props.id,
      country: countryFormat,
      onBlur: this.handleBlur,
      value: this.state.value,
      placeholder: placeholder,
      onChange: this.handleChange,
      displayInitialValueAsLocalNumber: true,
      onCountryChange: this.props.onCountryChange,
      "aria-describedby": this.props.ariaDescribedBy,
      "aria-invalid": errorList.length > 0,
      "aria-required": this.props.isRequired
    })), this.props.ariaDescription && /*#__PURE__*/_react.default.createElement(_styles.PhoneInputAriaDescriptor, {
      id: this.props.ariaDescribedBy
    }, this.props.ariaDescription), (0, _map.default)(errorList).call(errorList, error => /*#__PURE__*/_react.default.createElement(_styles.ErrorMessage, {
      key: `phone-input-error-${error}`
    }, error))));
  }
}
PhoneInput.defaultProps = {
  invalidMsg: 'Invalid phone number.',
  onChange: () => {},
  value: '',
  validate: true,
  placeholder: 'Phone Number',
  countryFormat: 'US'
};
PhoneInput.propTypes = {
  /**
   * The country code being looked for when a phone number is entered.
   */
  countryFormat: _propTypes.default.string,
  /**
   * The message to show if nothing has been entered into the input.
   */
  placeholder: _propTypes.default.string,
  /**
   * The message to show if the wrapped input's value is invalid.
   */
  invalidMsg: _propTypes.default.string,
  /**
   * The input's initial value.
   */
  initialValue: _propTypes.default.string,
  /**
   * callback called onChange and onBlur. Errors only provided onBlur
   * Ex: ({ value, error }) => {...}
   */
  onChange: _propTypes.default.func,
  /**
   * Determines whether the component should validate the input onBlur.
   */
  validate: _propTypes.default.bool,
  /**
   * Passes a country code when it changes.
   */
  onCountryChange: _propTypes.default.func,
  errors: _propTypes.default.array,
  id: _propTypes.default.string,
  ariaDescription: _propTypes.default.string,
  ariaDescribedBy: _propTypes.default.string,
  isRequired: _propTypes.default.bool,
  label: _propTypes.default.string
};
var _default = exports.default = PhoneInput;
PhoneInput.__docgenInfo = {
  "description": "Input that handles formatting and validation of phone numbers.\n\nUses React Phone Number Input\nhttp://catamphetamine.github.io/react-phone-number-input/docs/styleguide/index.html#phoneinput",
  "methods": [{
    "name": "handleChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleBlur",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "getPhoneValidationError",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "phoneNumber",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "PhoneInput",
  "props": {
    "invalidMsg": {
      "defaultValue": {
        "value": "'Invalid phone number.'",
        "computed": false
      },
      "description": "The message to show if the wrapped input's value is invalid.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "callback called onChange and onBlur. Errors only provided onBlur\nEx: ({ value, error }) => {...}",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "required": false
    },
    "validate": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Determines whether the component should validate the input onBlur.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "'Phone Number'",
        "computed": false
      },
      "description": "The message to show if nothing has been entered into the input.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "countryFormat": {
      "defaultValue": {
        "value": "'US'",
        "computed": false
      },
      "description": "The country code being looked for when a phone number is entered.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "initialValue": {
      "description": "The input's initial value.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onCountryChange": {
      "description": "Passes a country code when it changes.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "errors": {
      "description": "",
      "type": {
        "name": "array"
      },
      "required": false
    },
    "id": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "ariaDescription": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "ariaDescribedBy": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "isRequired": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "label": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};